<div class="container">
  <div class="title">Delivery service</div>
  <pdq-card color="white"
    ><div class="tracking">
      <div class="header">
        <b>Tracking number</b>
        @if (isEditingEnabled && !isEdit && (trackForm.value.trackingNumber || trackForm.value.trackingUrl)) {
          <pdq-button variant="light" (onClick)="toggleEdit()" plain="true" label="Edit"> </pdq-button>
        }
      </div>

      @if (isEditingEnabled && isEdit) {
        <div class="form">
          <div class="field-list">
            <pdq-input
              [value]="trackForm.value.trackingNumber"
              [dirty]="trackForm.controls.trackingNumber.dirty"
              [control]="trackForm.controls.trackingNumber"
              placeholder="Tracking number"
              variant="form"></pdq-input>
            <pdq-input
              [value]="trackForm.value.trackingUrl"
              [dirty]="trackForm.controls.trackingUrl.dirty"
              [control]="trackForm.controls.trackingUrl"
              placeholder="URL"
              variant="form"></pdq-input>
          </div>
          <div class="form__actions">
            <pdq-button [disabled]="isLoading" (onClick)="cancelEdit()" variant="light" label="Cancel"></pdq-button>
            <pdq-button variant="dark" [loading]="isLoading" (onClick)="save()" label="Save"></pdq-button>
          </div>
        </div>
      } @else {
        @if (trackForm.value.trackingNumber) {
          <div class="tracking__details">
            <pdq-link
              [clickable]="!!trackForm.value.trackingUrl"
              external="true"
              [label]="trackForm.value.trackingNumber"
              [url]="trackForm.value.trackingUrl">
            </pdq-link>
          </div>
        } @else {
          @if (isEditingEnabled) {
            <div class="tracking__add">
              <pdq-button
                variant="light"
                (onClick)="toggleEdit()"
                plain="true"
                label="+Add tracking number"></pdq-button>
            </div>
          } @else {
            <div class="tracking__add">
              <p>Missing tacking number</p>
            </div>
          }
        }
      }
    </div>
  </pdq-card>
</div>
